import { GoalStatus } from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const goalsTranslations = {
  GOAL: 'Goal',
  GOALS: 'Goals',
  GOALS_FOR: "{{name}}'s Goals",
  ADD_GOAL: 'Add goal',
  GOALS_EMPTY_LIST_TITLE: 'Goals will appear here',
  GOALS_EMPTY_LIST_DESCRIPTION:
    'Press that blue button at the top right of the page.',
  ARCHIVED: 'Archived',
  LAST_REVIEWED_ON: 'Last reviewed on',

  // statuses
  [GoalStatus.inProgress]: 'In progress',
  [GoalStatus.done]: 'Completed',
  [GoalStatus.notStarted]: 'Not started',
  [GoalStatus.paused]: 'Paused',
  [GoalStatus.archive]: 'Archived',
  // statuses

  // form
  ADD_A_GOAL_TITLE: 'Add a goal title...',
  DESCRIPTION: 'Description',
  DESCRIPTION_FIELD_DESCRIPTION:
    'What do you want to accomplish and why? What strengths do you already have that can be used to acheive this?',
  START_TYPING: 'Start typing...',
  MEASURE_OF_SUCCESS: 'Measure of Success',
  MEASURE_OF_SUCCESS_DESCRIPTION:
    'How will you know that the goal is achieved?',
  DURATION: 'Duration',
  GOAL_DURATION: 'Goal Duration',
  DURATION_DESCRIPTION: 'When will this start and when should it be achieved?',
  IMPORTANCE: 'Importance',
  IMPORTANCE_DESCRIPTION:
    'How important is achieving this goal to the {{nominative}}?',
  ACTION_PLAN: 'Action Plan',
  ACTION_PLAN_DESCRIPTION:
    'What steps we are planning to take to achieve this goal?',
  ADD_MILESTONE: 'Add new milestone',
  ACCTION_NO_TITLE: "This Action doesn't have a title... ",
  ATTACHED_DOCUMENTS: 'Attached Documents',
  ADD_DOCUMENT: 'Add Document',
  NOTES: 'Notes',
  WRITE_UPDATE: 'Write an update',
  GOAL_STATUS: 'Goal Status',
  LEVEL: 'Level',
  ADD_SIGNATURE: 'Add signature',
  EXPORT_GOAL: 'Export',
  CONFIRM: 'Confirm',
  IN_RISK_ASSESMENTS: 'In {{number}} Risk Assesments',
  LINKED: 'Linked',
  ADDED_X_DAYS_AGO: 'Added {{days}} days ago',
  ADDED_TODAY: 'Added today',
  WARNING: 'Warning',
  ARE_YOU_SURE: 'Are you sure you want to do this?',
  CHANGES_NOT_SAVED:
    'The changes you’ve made have not been saved and will be lost ',
  ACTION_NO_TITLE: `This Action doesn't have a title... `,
  // Care Plans VS Support plans
  'Care Plans': 'Care Plans',
  'LINK_Care Plans': 'Link Care Plan',
  'SELECT_Care Plans': 'Select from available Care Plans',
  'NO_Care Plans':
    'No Care Plans. You will be able to link Care Plans to this goal once you have created them.',
  'ASSOCIATED_Care Plans': 'Associated Care Plans',
  'Support Plans': 'Support Plans',
  'LINK_Support Plans': 'Link Support Plan',
  'SELECT_Support Plans': 'Select from available Support Plans',
  'NO_Support Plans':
    'No Support Plans. You will be able to link Support Plans to this goal once you have created them.',
  'ASSOCIATED_Support Plans': 'Associated Support Plans',
  SAVED: 'Goal saved',
  ERROR: 'Oops, something went wrong. Please try again.',
  TITLE_IN_USE_ERROR:
    'A goal with the same title already exist; please change the title to continue',
  SELECT_FROM_AVAILABLE_GOALS: 'Select from available goals',
  GOAL_MANAGEMENT: 'Goal Management',
  PRIORITY_LEVEL: 'Priority level',
  PRIORITY_LEVEL_TOOLTIP:
    'Prioritised on a scale of 1 (lowest) to 10 (highest).',
  GOAL_START_DATE: 'Goal start date',
  GOAL_END_DATE: 'Goal end date',
  PROGRESS_INDICATOR: 'Goal progress indicator',
  CURRENT_AMOUNT: 'Current amount: {{variable}}%',
  MILESTONES: 'Milestones',
  FROM: 'From',
  TO: 'To',
  SET_PRORITY: 'Set priority level',
  SELECT_DATE_RANGE: 'Select the date range',
  COMPLETED: 'Completed Goals',
  GOAL_PROGRESS: 'Goal progress',
  GOAL_PROGRESS_DESCRIPTION:
    'This is where you can advance, the progress of your goal',
  BEFORE_REVIEW: 'Before review: {{variable}}%',
  CURRENT: 'Current: {{variable}}%',
  AUTOMATIC_LOG_LINKING: 'Automatic Log Linking',
  LOG_LINKING_DESCRIPTION:
    'This feature will automatically link all logs you select here, to this goal.',
  LOG_LINKING_DESCRIPTION_VIEW:
    'All logs shown here will be automatically linked to this goal',
  REQUEST_LOG_TYPES: 'Request more log types here',
  NO_REVIEW_SET: 'No review set',

  // validation
  NEXT_REVIEW_VALUE_BETWEEN_DURATION:
    'Next review date should be between start date and end date',
  NEXT_REVIEW_VALIDATION_ERROR:
    'The selected date must be today or a future date',
  REQUIRED_MESSAGE: 'This is a required field',
  ADD_TITLE_ACTION_ERROR: 'You need to add a title in order to save goal',
  ACTION_TITLES_REQUIRED: 'Some actions are missing title',
  PERCENTAGE_PLACEHOLDER: 'Enter percentage',
  STATUS_CHANGE: 'Status was automatically changed to ‘{{variable}}’',

  // view
  DOWNLOAD_PDF: 'Download PDF',
  REVIEW: 'Review',
  LAST_UPDATED: 'Last update',
  NEXT_REVIEW_DUE: 'Next review due',
  START_DATE: 'Start date',
  END_DATE: 'End date',

  // TIMELINE
  TIMELINE: 'Timeline',
  FILTER_BY: 'Filter by',
  DAILY_LOGS: 'Daily logs',
  SIGNATURES: 'Signatures',
  NOTE_LOGS: 'Note Logs',
  CHANGE_LOGS: 'Change Logs',
  REVIEW_NOTES: 'Review Notes',
  REVIEWS: 'Reviews',

  'Daily summary': 'Daily logs',
  Signature: 'Signatures',
  'Goal Timeline - Note Event': 'Note Logs',
  'Goal Timeline - Change Event': 'Change Logs',
  reviewNotes: 'Review Notes',

  // edit
  CANCEL: 'Cancel',
  SAVE: 'Save',
  EDIT: 'Edit',
  UNLINK: 'Unlink',
  OPEN_MENU: 'Open menu',

  // coming soon
  COMING_SOON_CARD_TITLE: 'Outcomes & Goals',
  COMING_SOON_CARD_SUBTITLE:
    'Exciting News! We will soon be releasing our new outcomes and goals feature.',
  FEATURE_LIST_ROW_1: 'Set goals for your clients and evidence progress',
  FEATURE_LIST_ROW_2:
    'Create an action plan for each goal and add relevant documents',
  FEATURE_LIST_ROW_3: 'Link care plans to each goal',
  FEATURE_LIST_ROW_4: 'Empower your clients to digitally sign their goals',
  FEATURE_LIST_ROW_5: 'Track goals’ progress by linking logs',
  FEATURE_LIST_ROW_6: 'Review goals',
  COMING_SOON_CARD_DESCRIPTION: "With this new feature you'll be able to:",
  COMING_SOON_CARD_FOOTER_TEXT:
    'Help your clients achieve what matters most to them.',

  DESCRIPTION_ROW_1: 'Click ‘Register’ to be notified ',
  DESCRIPTION_ROW_2: 'when this feature is released.',

  ADD_CONTENTS_ROW_1: 'Add a goal',
  ADD_CONTENTS_ROW_2: 'to enrich the',
  ADD_CONTENTS_ROW_3: 'lives of',
  ADD_CONTENTS_ROW_4: 'your clients',

  CREATE_CONTENTS_ROW_1: 'Don’t just',
  CREATE_CONTENTS_ROW_2: 'talk about it',
  CREATE_CONTENTS_ROW_3: 'Create an',
  CREATE_CONTENTS_ROW_4: 'action',

  // early access
  EARLY_ACCESS_TITLE: 'Early Access',
  EARLY_ACCESS_DESCRIPTION:
    'This is a new feature, please feel free to share your feedback',
  EARLY_ACCESS_BUTTON_TEXT: 'Share feedback',

  // care plans
  // we should not add things for other pages here, but we are doing an exeption because enTranslations.ts is already full

  // Review Dates
  LINK_A_GOAL: 'Link a goal',
  THREE_MONTHS: '3 Months',
  SIX_MONTHS: '6 Months',
  ONE_YEAR: 'One Year',
  ONE_WEEK: '1 week',
  ONE_MONTH: '1 month',
  NO_FURTHER_SUPPORT_REQUIRED: 'No further support required',
  NEXT_REVIEW: 'Next review',

  // home card
  SU_GOAL_IN_PROGRESS: '{{nominative}} with a goal in progress',
  GOALS_COMPLETED_30_DAYS: 'Goals completed in the last 30 days',
  SU_ACTIVE_GOAL: 'of {{nominative}} with active goals',
  NO_OVERDUE: '{{variable}} Overdue',
  GOALS_DASHBOARD: 'Goals Dashboard',
  UPDATED_FEATURE: `We've made a big update to our goals feature!`,
  CHECK_OUT: 'Check out the new card below',
  SCROLL: 'Scroll to goals card'
}

export const goalsConstants = getKeys(goalsTranslations)
